var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFornecedorDinheiro01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1537",
    d: "M4,27.7v-1.4c0-1.7,1.3-3,3-3h12.5c0.7,0,1.3,0.6,1.3,1.3c0,0.3-0.1,0.6-0.3,0.8l-0.3,0.2l0,0 C20,25.9,19.7,26,19.5,26h-6.5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.2,1.3,1.3h6.5c1.1,0,2.1-0.5,2.9-1.3l7.5-6.9l0,0 c0.5-0.5,1.3-0.5,1.8,0c0.5,0.5,0.5,1.3,0,1.8l-6.6,6.1l0,0c-3,2.9-7,4.5-11.2,4.5H2.7c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h11.2 c4.8,0,9.5-1.9,13-5.2l6.6-6.1l0,0c1.5-1.5,1.5-4,0-5.5c-1.5-1.5-3.9-1.5-5.4-0.1l-5,4.6c-0.6-1.4-2-2.4-3.6-2.4H7 c-3.1,0-5.6,2.5-5.6,5.6v1.4C1.4,28.4,2,29,2.7,29C3.4,29,3.9,28.4,4,27.7L4,27.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1538",
    d: "M9.4,9.4c0.2,4.8,4.2,8.4,9,8.2c4.8-0.2,8.4-4.2,8.2-9c-0.2-4.8-4.2-8.4-9-8.2l0,0 C12.9,0.7,9.2,4.7,9.4,9.4z M25.1,8.8c0.2,3.9-2.9,7.2-6.7,7.3c-3.9,0.2-7.2-2.9-7.3-6.7c-0.2-3.9,2.9-7.2,6.7-7.3c0,0,0,0,0,0 C21.6,1.9,24.9,4.9,25.1,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1539",
    d: "M16.9,4.4l0,0.9c-1.2,0.5-1.8,1.9-1.3,3.1c0.4,0.9,1.3,1.5,2.3,1.5c0.4,0,0.8,0.3,0.8,0.7 s-0.3,0.8-0.7,0.8c-0.4,0-0.8-0.2-1-0.5c-0.3-0.3-0.8-0.3-1.1,0c-0.3,0.3-0.3,0.8,0,1.1c0.4,0.4,0.9,0.8,1.5,1l0,0.9 c0,0.4,0.4,0.7,0.8,0.7c0.4,0,0.7-0.4,0.7-0.8l0-0.9c1.2-0.5,1.8-1.9,1.3-3.1c-0.4-0.9-1.3-1.5-2.3-1.5C17.4,8.3,17,8,17,7.6 c0-0.4,0.3-0.8,0.7-0.8c0.3,0,0.6,0.1,0.9,0.4C19,7.4,19.4,7.3,19.7,7C20,6.7,20,6.2,19.7,5.9c-0.3-0.3-0.7-0.5-1.2-0.7l0-0.9 c0-0.4-0.3-0.8-0.8-0.8C17.2,3.6,16.9,3.9,16.9,4.4C16.9,4.4,16.9,4.4,16.9,4.4L16.9,4.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFornecedorDinheiro01);
export default __webpack_public_path__ + "static/media/ico-fornecedor-dinheiro-01.f9a692607765d16cf0212b650757b3df.svg";
export { ForwardRef as ReactComponent };